/**
 * 规则：
 * 一、例如：index/index，shop/index以index结尾的，path和name默认去除index
 * 二、例如：shop/list，默认生成name为shop_list（如果结尾为index，例如shop/index则是shop）
 * 三、填写后不会自动生成
 * **/
let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [{
				meta: {
					title: '正汉好医'
				},
				component: 'home/home/index'
			}, {
				meta: {
					title: '后台首页'
				},
				component: 'index/index'
			},
			{
				meta: {
					title: '商品列表',
					keepAlive: true
				},
				component: 'shop/goods/list'
			},
			{
				meta: {
					title: '创建商品'
				},
				component: 'shop/goods/create'
			},
			{
				meta: {
					title: '修改商品详情'
				},
				component: 'shop/goods/content'
			},
			{
				meta: {
					title: '媒体设置'
				},
				component: 'shop/goods/banner'
			},
			{
				meta: {
					title: '商品属性'
				},
				component: 'shop/goods/attr'
			},
			{
				meta: {
					title: '商品规格'
				},
				component: 'shop/goods/sku'
			},
			{
				meta: {
					title: '分类管理'
				},
				component: 'shop/category/list'
			},
			{
				meta: {
					title: '商品规格管理'
				},
				component: 'shop/sku/list'
			},
			{
				meta: {
					title: '商品类型管理'
				},
				component: 'shop/type/list'
			},
			{
				meta: {
					title: '商品评论管理'
				},
				component: 'shop/comment/list'
			},
			// 淘宝客
			{
				meta: {
					title: "选品组"
				},
				component: 'shop/group/index'
			},
			{
				meta: {
					title: '商品列表'
				},
				component: 'shop/group/list'
			},
			// 商品管理
			{
				meta: {
					title: '商品列表'
				},
				component: 'shop/category2/list'
			},
			{
				meta: {
					title: '分类列表'
				},
				component: 'shop/category2/classify'
			},
			{
				meta: {
					title: '品牌列表'
				},
				component: 'shop/category2/brand'
			},
			{
				meta: {
					title: '规格列表'
				},
				component: 'shop/category2/norms'
			},
			{
				meta: {
					title: '模型列表'
				},
				component: 'shop/category2/model'
			},

			{
				meta: {
					title: '相册管理'
				},
				component: 'image/index'
			},


			{
				meta: {
					title: '发票管理'
				},
				component: 'order/invoice/list'
			},
			{
				meta: {
					title: '售后服务'
				},
				component: 'order/after-sale/list'
			},
			{
				meta: {
					title: '订单列表'
				},
				component: 'order/order/list'
			},
			{
				meta: {
					title: '康腾订单'
				},
				component: 'order/order/Ktlist'
			},
			{
				meta: {
					title: '邀请列表',
				},
				component: 'user/inv-list/list'
			},
			{
				meta: {
					title: '会员列表',
					keepAlive: true
				},
				component: 'user/user-list/list'
			},
			{
				meta: {
					title: '会员等级'
				},
				component: 'user/user-level/list'
			},
			{
				meta: {
					title: '会员体系'
				},
				component: 'user/user-member/member'
			},
			{
				meta: {
					title: '勋章体系'
				},
				component: 'user/user-medal/medal'
			},
			{
				meta: {
					title: '规则体系'
				},
				component: 'user/user-rule/rule'
			},
			{
				meta: {
					title: '积分规则'
				},
				component: 'user/user-rules/rules'
			},
			{
				meta: {
					title: '基础设置'
				},
				component: 'set/base/index'
			}, {
				meta: {
					title: '模块设置'
				},
				component: 'set/modset/index'
			},
			{
				meta: {
					title: '物流设置'
				},
				component: 'set/express/index'
			},
			{
				meta: {
					title: '管理员管理'
				},
				component: 'set/manager/index'
			},
			{
				meta: {
					title: '交易设置'
				},
				component: 'set/payment/index'
			},
			{
				meta: {
					title: '通用参数'
				},
				component: 'set/common/index'
			},
			{
				meta: {
					title: '部门设置'
				},
				component: 'set/depart/index',
			},
			{
				meta: {
					title: '医院设置'
				},
				component: 'set/hospital/index'
			},
			{
				meta: {
					title: '科室设置'
				},
				component: 'set/section/index'
			},
			{
				meta: {
					title: '职称设置'
				},
				component: 'set/company/index'
			},
			{
				meta: {
					title: '地区设置'
				},
				component: 'set/area/index'
			},
			{
				meta: {
					title: '问题模块'
				},
				component: 'modular/problem/index'
			},
			{
				meta: {
					title: '选项模块'
				},
				component: 'modular/option/index'
			},
			{
				meta: {
					title: '问卷模块'
				},
				component: 'modular/paper/index'
			},
			{
				meta: {
					title: '医生入驻'
				},
				component: 'set/settle/index'
			},
			{
				meta: {
					title: '医生入驻报表'
				},
				component: 'set/settle/docrzbb'
			},
			{
				meta: {
					title: '达人入驻'
				},
				component: 'set/settle/indexDr'
			},
			{
				meta: {
					title: '维度设置'
				},
				component: 'knowledge/dimen/index'
			},
			{
				meta: {
					title: '诊疗中心'
				},
				component: 'knowledge/disease/index'
			},
			{
				meta: {
					title: '文章管理'
				},
				component: 'knowledge/manage/index'
			},
			{
				meta: {
					title: '类别设置'
				},
				component: 'header/type/list'
			},
			{
				meta: {
					title: '图文展示'
				},
				component: 'header/picture/list'
			},	{
				meta: {
					title: '正汉健康资讯'
				},
				component: 'header/picture/zhhlwyylist'
			},
			{
				meta: {
					title: '视频展示'
				},
				component: 'header/video/list'
			},
			{
				meta: {
					title: '音频展示'
				},
				component: 'header/audio/list'
			},
			{
				meta: {
					title: '发帖详情'
				},
				component: 'community/table/index'
			}, {
				meta: {
					title: '回帖详情'
				},
				component: 'community/reply/index'
			},

			{
				meta: {
					title: '版主管理'
				},
				component: 'community/classteacher/index'
			},
			{
				meta: {
					title: '圈子中心'
				},
				component: 'community/square/index'
			}, {
				meta: {
					title: '社区流量报表'
				},
				component: 'community/report/flowreport'
			}, {
				meta: {
					title: '用户活动度报表'
				},
				component: 'community/report/activityreport'
			},
			{
				meta: {
					title: '社区分类管理'
				},
				component: 'doctor_community/doctor/index'
			},
			{
				meta: {
					title: '社区帖子管理'
				},
				component: 'doctor_community/PostManagement/index'
			},
			{
				meta: {
					title: '问答展示'
				},
				component: 'question/table/index'
			},
			{
				meta: {
					title: '问答列表'
				},
				component: 'QA/qaSettings/index'
			},
			{
				meta: {
					title: '问答金额'
				},
				component: 'QA/qaAmount/index'
			},
			{
				meta: {
					title: '标签设置'
				},
				component: 'QA/qaTab/index'
			},
			{
				meta: {
					title: '咨询常用语'
				},
				component: 'changYy/list/index'
			}, {
				meta: {
					title: '类别设置'
				},
				component: 'changYy/type/typelist'
			},
			{
				meta: {
					title: '直播展示'
				},
				component: 'broadcast/live/index'
			},
			{
				meta: {
					title: 'MCN审核'
				},
				component: 'set/economic/index'
			}, {
				meta: {
					title: 'MCN列表'
				},
				component: 'set/economic/list'
			},
			{
				meta: {
					title: '二维码物料'
				},
				component: 'doctor/ewm/index'
			},
			{
				meta: {
					title: '医生邀请记录'
				},
				component: 'doctor/invite/index'
			},
			{
				meta: {
					title: '活动公告'
				},
				component: 'systemnoc/activity/list'
			},
			{
				meta: {
					title: '系统通知'
				},
				component: 'systemnoc/sysmsg/index'
			},
			{
				meta: {
					title: '活动'
				},
				component: 'activitytab/list/index'
			}, {
				meta: {
					title: '快康报表'
				},
				component: 'kkbb/list/report'
			},
			{
				meta: {
					title: '流量报表'
				},
				component: 'kkbb/list/flow'
			}, {
				meta: {
					title: '在线问答报表'
				},
				component: 'kkbb/list/answerDatas'
			},
			{
				meta: {
					title: '推广费用录入'
				},
				component: 'tgfyadd/list/tgfy_add'
			}, {
				meta: {
					title: '推广费指标上传'
				},
				component: 'tgfyadd/list/tgfy_zbsz'
			}, {
				meta: {
					title: '广告位设置'
				},
				component: 'set/adsense/index'
			}, {
				meta: {
					title: '操作日志'
				},
				component: 'set/record/index'
			}, {
				meta: {
					title: '监管大屏'
				},
				component: 'set/record/echartindex'
			},
			{
				meta: {
					title: 'app设置'
				},
				component: 'set/app/index'
			},
			{
				meta: {
					title: '咨询赠送次数设置'
				},
				component: 'zxCount/list/zx_count'
			}, {
				meta: {
					title: '医生创作报表'
				},
				component: 'docfbbb/list/index'
			}, {
				meta: {
					title: '医生业务数据报表'
				},
				component: 'docfbbb/list/ywsjbb'
			},
			{
				meta: {
					title: '医生运营专家经纪分配表'
				},
				component: 'docfbbb/list/yssj'
			}, {
				meta: {
					title: '个人业务数据报表'
				},
				component: 'docfbbb/list/grywsjbb'
			},
			{
				meta: {
					title: '医生创作订单管理'
				},
				component: 'docfbbb/order/index'
			},
			{
				meta: {
					title: '医生评价管理'
				},
				component: 'docfbbb/list/pingjia'
			},
			{
				meta: {
					title: '穴位望诊'
				},
				component: 'xueweiwz/list/index'
			},
			// 训练

			{
				meta: {
					title: '训练展示'
				},
				component: 'train/table/index'
			},
			// 平台
			{
				meta: {
					title: '公众号'
				},
				component: 'platform/platform/index'
			},
			// table
			{
				meta: {
					title: '医生数据报表'
				},
				component: 'table/list/index'
			},
			{
				meta: {
					title: '运营数据报表'
				},
				component: 'table/operate/index'
			},
			{
				meta: {
					title: '医生明细'
				},
				component: 'table/mcn/doctor'
			},{
				meta: {
					title: '医生工作室团队'
				},
				component: 'table/mcn/doctorTeam'
			},
			{
				meta: {
					title: '用户报到明细'
				},
				component: 'table/mcn/usereport'
			},
			{
				meta: {
					title: '用户报到总表'
				},
				component: 'table/mcn/usereportall'
			},
			{
				meta: {
					title: '用户报到报表'
				},
				component: 'table/mcn/usereportbb'
			},
			{
				meta: {
					title: '入驻报表'
				},
				component: 'table/mcn/settle'
			},
			{
				meta: {
					title: '咨询报表'
				},
				component: 'table/mcn/cousult'
			},
			{
				meta: {
					title: '收支报表'
				},
				component: 'table/mcn/income'
			},
			{
				meta: {
					title: '收支明细报表'
				},
				component: 'table/mcn/income-mx'
			},
			{
				meta: {
					title: '平台收支报表'
				},
				component: 'table/mcn/incomeping'
			},
			{
				meta: {
					title: '咨询明细报表'
				},
				component: 'table/mcn/cousult-mx',
			},
			
			{
				meta: {
					title: '内容数据运营报表'
				},
				component: 'table/content/index'
			},
			{
				meta: {
					title: '电商平台报表'
				},
				component: 'table/content/shop'
			},
			{
				meta: {
					title: '商城数据中心'
				},
				component: 'table/shopDataC/shopDataC'
			},
			{
				meta: {
					title: '内容生产报表'
				},
				component: 'table/contentsc/index'
			}, {
				meta: {
					title: '内容互动分发报表'
				},
				component: 'table/contenthandf/index'
			},
			{
				meta: {
					title: '助理管理'
				},
				component: 'addassistant/list/index'
			}, {
				meta: {
					title: '直播管理'
				},
				component: 'Live/list/index'
			},
			{
				meta: {
					title: '工作室'
				},
				component: 'office/list/index'
			},
			{
				meta: {
					title: '平台攻略'
				},
				component: 'Strategy/list/index'
			},
			{
				meta: {
					title: '报名表'
				},
				component: 'bm/list/index'
			}, {
				meta: {
					title: '学术交流'
				},
				component: 'xueshu/list/index'
			},
			{
				meta: {
					title: '提现审核'
				},
				component: 'Withdrawal/list/index'
			},
			{
				meta: {
					title: '医生资金明细'
				},
				component: 'Withdrawal/zjlist/index'
			}, {
				meta: {
					title: '医生账户资金'
				},
				component: 'Withdrawal/docmoneys/index'
			},
			{
				meta: {
					title: '调查问卷管理'
				},
				component: 'Survey/list/index'
			},
			{
				meta: {
					title: '购物优惠券'
				},
				component: 'shopcoupon/list/index'
			}, {
				meta: {
					title: '咨询优惠券'
				},
				component: 'shopcoupon/list/indexzx'
			}, {
				meta: {
					title: '小程序反馈投诉'
				},
				component: 'feekback/list/index'
			}, {
				meta: {
					title: '小程序预约'
				},
				component: 'xcxyy/list/index'
			}, {
				meta: {
					title: '心理好课'
				},
				component: 'mentalhealth/video/list'
			}, {
				meta: {
					title: '中药'
				},
				component: 'zhongyao/list/index'
			}, {
				meta: {
					title: '中药分类'
				},
				component: 'zhongyao/list/types'
			}, {
				meta: {
					title: '按方开药'
				},
				component: 'zhongyao/list/anfky'
			}, {
				meta: {
					title: '内容管理'
				},
				component: 'zhihuiKF/list/list'
			}, {
				meta: {
					title: '分类管理'
				},
				component: 'zhihuiKF/list/types'
			},
			{
				meta: {
					title: '账户管理'
				},
				component: 'caiwu/zhanghu/index'
			},
			{
				meta: {
					title: '交易记录'
				},
				component: 'caiwu/jiaoyi/index'
			},
			{
				meta: {
					title: '咨询交易记录'
				},
				component: 'caiwu/jiaoyi/indexzx'
			},
			{
				meta: {
					title: '内容交易记录'
				},
				component: 'caiwu/jiaoyi/indexnr'
			},
			{
				meta: {
					title: '商城交易记录'
				},
				component: 'caiwu/jiaoyi/indexsc'
			},
			{
				meta: {
					title: '结算管理'
				},
				component: 'caiwu/jiesuan/index'
			},




			//疾病分类
			{
				meta: {
					title: '疾病分类'
				},
				component: 'set/disease_type/index'
			},
			{
				meta: {
					title: 'app首页设置'
				},
				component: 'app/index'
			},
			{
				meta: {
					title: '404错误'
				},
				component: 'error/404'
			},
			{
				meta: {
					title: '聊天咨询'
				},
				component: 'chat/client/user'
			},
			{
				meta: {
					title: '付费咨询'
				},
				component: 'chatPay/client/user'
			},
			//客服
			{
				meta: {
					title: '客服聊天'
				},
				component: 'cusSer/client/user'
			}, {
				meta: {
					title: '常用语'
				},
				component: 'cusSer/set/changyongyu'
			}, {
				meta: {
					title: '咨询用户管理'
				},
				component: 'cusSer/userList/list'
			},

			{
				meta: {
					title: '商品邀请报表'
				},
				component: 'goodsinvbb/list/index'
			}, {
				meta: {
					title: '推荐用户报表'
				},
				component: 'goodsinvbb/list/tuijianbb'
			}, {
				meta: {
					title: '医生账户资金'
				},
				component: 'docCaiwu/list/yszhzj'
			},
			{
				meta: {
					title: '医生资金明细'
				},
				component: 'docCaiwu/list/yszjmx'
			},

			// MCN
			{
				meta: {
					title: '设置'
				},
				component: 'MCN/set/index'
			},
			{
				meta: {
					title: '视频管理'
				},
				component: 'MCN/video/list'
			}, {
				meta: {
					title: '首页'
				},
				component: 'MCN/index/index'
			}, {
				meta: {
					title: '平台公告'
				},
				component: 'MCN/actmsg/list'
			},
			{
				meta: {
					title: '财务明细'
				},
				component: 'MCN/caiwu/cwmx'
			},
			{
				meta: {
					title: '银行账户'
				},
				component: 'MCN/caiwu/yhzh'
			},
			{
				meta: {
					title: '机构提现'
				},
				component: 'MCN/caiwu/jgtx'
			},
			{
				meta: {
					title: '粉丝列表'
				},
				component: 'user/fensi/list'
			},
			{
				meta: {
					title: '用户详情'
				},
				component: 'user/user-list/details'
			},
			{
				meta: {
					title: '家庭档案'
				},
				component: 'user/user-list/family'
			},
			{
				meta: {
					title: '模板管理'
				},
				component: 'user/user-template/moban'
			},
			{
				meta: {
					title: '标签管理'
				},
				component: 'user/user-label/label'
			},
			{
				meta: {
					title: '奖池管理'
				},
				component: 'luckdraw/paper/index'
			},
			{
				meta: {
					title: '邀请好友图'
				},
				component: 'invitation/list/index'
			},
			{
				meta: {
					title: '兑换码管理'
				},
				component: 'rwb/dhm/index'
			},
			{
				meta: {
					title: '发送信息管理'
				},
				component: 'user/sendMessage/index'
			},
			{
				meta: {
					title: '平台内容报表'
				},
				component: 'kkbb/list/alldatas'
			},
			{
				meta: {
					title: '用户行为分析表'
				},
				component: 'kkbb/list/behaviorAnalysis'
			}, {
				meta: {
					title: '平台流量报表'
				},
				component: 'kkbb/list/alldatasflow'
			}, {
				meta: {
					title: '渠道分析报表'
				},
				component: 'kkbb/list/channelAnalysis'
			},
			{
				meta: {
					title: '训练课程购买'
				},
				component: 'xunlianpay/list/index'
			},
			{
				meta: {
					title: '0元购活动'
				},
				component: 'activity/lygactivity/index'
			},
			{
				meta: {
					title: '分会信息设置'
				},
				component: 'branch/branchInfo/index'
			},
			{
				meta: {
					title: '任务宝设置'
				},
				component: 'publicAccount/index'
			}, {
				meta: {
					title: '业务员管理'
				},
				component: 'salesman/list/index'
			},
			{
				meta: {
					title: '诊疗金管理'
				},
				component: 'diagnosis/list/index'
			},
			{
				meta: {
					title: '咨询设置'
				},
				component: 'table/mcn/videoSetUp'
			},
			{
				meta: {
					title: '内容运营大屏'
				},
				component: 'iframe/iframe/index'
			},
		]
	},
	{
		meta: {
			title: '登录页'
		},
		component: 'login/index'
	},
	{
		meta: {
			title: '注册'
		},
		component: 'register/index'
	}, {
		meta: {
			title: '注册'
		},
		component: 'register/choose'
	}, {
		meta: {
			title: '忘记密码'
		},
		component: 'register/forgetpwd'
	},
	{
		meta: {
			title: '服务条款'
		},
		component: 'tks/service'
	},
	{
		meta: {
			title: '隐私说明'
		},
		component: 'tks/Lineysbh'
	},



	{
		path: '*',
		redirect: {
			name: 'index'
		},
	}
]

// 获取路由信息方法
let getRoutes = function () {
	// 自动生成路由
	createRoute(routes)
	return routes
}

// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// console.log(val);
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成path
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}

// 去除index
function getValue(str) {
	// str = login/index
	// 获取最后一个/的索引
	let index = str.lastIndexOf('/')
	// 获取最后一个/后面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}

export default getRoutes()